import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { Chart, LineController, LineElement, PointElement, LinearScale, Title, CategoryScale } from 'chart.js';
import LineChart from './LineChart';
import BarChart from './BarChart';
import api from '../../api/axiosInstance';

Chart.register(LineController, LineElement, PointElement, LinearScale, Title, CategoryScale);

function AdminDashboard() {
    const [AdminDm, setAdminDm] = useState(null);

    useEffect(() => {
        const fetchUserCounts = async () => {
            try {
                const response = await api.get('/Administration');
                setAdminDm(response.data);
            } catch (error) {
                console.error("Error fetching Admin Data:", error);
            }                                                                                                                                                                                                       
        };                                                                                                                                                                                                                                                                                                                                                                                                                  

        fetchUserCounts();
    }, []);

    // Enhanced loading state
    if (!AdminDm) {
        return (
            <div className="loading-container" style={{ textAlign: 'center', marginTop: '150px' }}>
                <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="sr-only">Loading...</span>
                </div>
                <h4 style={{ marginTop: '20px' }}>Loading admin data, please wait...</h4>
            </div>
        );
    }

    // Define your tiles
    const tiles = [
        { label: 'Total Users', count: AdminDm.totalUsers },
        { label: 'Total Admins', count: AdminDm.totalAdmins },
        { label: 'Total Designers', count: AdminDm.totalDesigners },
        { label: 'Total Approvers', count: AdminDm.totalApprovers },
        { label: 'Form Masters', count: AdminDm.formMasters },
        { label: 'Forms to Approve', count: AdminDm.formsToApproveCount },
        { label: 'Total Forms', count: AdminDm.totalForms },
        { label: 'Error Logs', count: AdminDm.errorLogs },
    ];

    // Define color classes
    const colorClasses = ['bg-primary', 'bg-success', 'bg-warning', 'bg-danger'];
    const numTilesPerRow = 4;

    // Calculate the number of rows needed
    const rows = [];
    for (let i = 0; i < tiles.length; i += numTilesPerRow) {
        rows.push(tiles.slice(i, i + numTilesPerRow));
    }

    return (
        <>
            <Helmet>
                <title>Admin Dashboard</title>
            </Helmet>
            <div>
                {rows.map((row, rowIndex) => {
                    // Determine color classes for the current row
                    const currentColorClasses = rowIndex % 2 === 0 ? colorClasses : [...colorClasses].reverse();

                    return (
                        <div className="row" key={rowIndex} style={{ marginTop: '0px' }}>
                            {row.map((tile, index) => (
                                <div className="col-lg-3 col-6" key={index}>
                                    <div className={`small-box ${currentColorClasses[index]}`}>
                                        <div className="inner">
                                            <h3>{tile.count}</h3>
                                            <p>{tile.label}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    );
                })}

                <div className="row" style={{ marginTop: '10px' }}>
                    <div className="col-lg-6">
                        <LineChart data={AdminDm.past7DaysSubmittedForms} />
                    </div>
                    <div className="col-lg-6">
                        <BarChart data={AdminDm.past7MonthsSubmittedForms} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default AdminDashboard;
